module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_callme", [["div",{"class":"pad-tb pad-lr call-me-page"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"callmeTitle","data-fox-context":"callme"},[["textNode",{"text":"Call me"}]]]]],["div",{"class":"verifiedcall-wrapper border-color-3-trans-20"},[["div",{"class":"verifiedcall-widget"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/callme.tpl
// module id = 1206
// module chunks = 4